import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "standard-skip-nav-content",
  template: `<div id="skip-nav"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardSkipNavContentComponent {}
